// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import vgrpEntity from './entities/vgrp.json';
import vgrpMenu from '../pages/vgrp/menu.json';
import vgrpFullForm from '../pages/vgrp/forms/full.json';
import vgrpContextForm from '../pages/vgrp/forms/context.json';
import vgrpMiniForm from '../pages/vgrp/forms/mini.json';
import vgrpLookupForm from '../pages/vgrp/forms/lookup.json';
import vgrpTableView from '../pages/vgrp/views/table.json';
import vgrpStagesView from '../pages/vgrp/views/stages.json';
import vgrpCardsView from '../pages/vgrp/views/cards.json';
import vgrpInlineView from '../pages/vgrp/views/inline.json';
import vgrpBacklogView from '../pages/vgrp/views/backlog.json';
import vgrpSplitView from '../pages/vgrp/views/split.json';
import vgrpCalendarView from '../pages/vgrp/views/calendar.json';
import vgrpDashboardView from '../pages/vgrp/views/dashboard.json';

/** Тип запису «Група виборців» зі сторінками пакета: меню, форми та подання з pages/vgrp/. */
export const vgrpDefinition: IRecordTypeDefinition = {
  ...vgrpEntity,
  views: assembleViewSet({
      table: vgrpTableView,
      stages: vgrpStagesView,
      cards: vgrpCardsView,
      inline: vgrpInlineView,
      backlog: vgrpBacklogView,
      split: vgrpSplitView,
      calendar: vgrpCalendarView,
      dashboard: vgrpDashboardView,
  }),
  form: vgrpFullForm,
  forms: { full: vgrpFullForm, context: vgrpContextForm, mini: vgrpMiniForm, lookup: vgrpLookupForm },
  menu: vgrpMenu,
} as IRecordTypeDefinition;
